"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _constructor = _interopRequireDefault(require("../../../constants/constructor"));

/* istanbul ignore file */
class RouterWithConstraintsDecorator {
  [_constructor.default]() {
    this.constraints = {};
  }
  /**
   * @param {string} constraintName
   * @param {RegExp} validator
   */


  setConstraint(constraintName, validator) {
    this.constraints[constraintName] = validator;
    return this;
  }

  setConstraints(constraints) {
    this.constraints = constraints;
  }

  getConstraint(constraintName) {
    return this.constraints[constraintName];
  }

  getConstraints() {
    return this.constraints;
  }

}

exports.default = RouterWithConstraintsDecorator;